import * as z from 'zod';
import * as ba from './base';
import { SCRIPT_SCHEMA } from '../scripting';
export class ScriptAction extends ba.Action {
    static get manifest() {
        return {
            name: 'script',
            schema: z.object({
                value: SCRIPT_SCHEMA()
            })
        };
    }
    static callableParameterNames = ['value'];
    async handle(event, args) {
        await args.value();
        return null;
    }
}
//# sourceMappingURL=script.js.map